<template>
  <div class="nav-container" @keyup="keyUp($event)">
    <div v-if="drawer" class="nav-overlay animated fadeIn" @click="drawer = !drawer"></div>
    <nav class="nav-menu" :class="drawer?'active':''">
      <button @click.stop="drawer = !drawer, openNav()" class="nav-control" :aria-label="drawer?'Cerrar menú de navegación':'Abrir menú de navegación'" aria-hidden :aria-expanded="drawer?'true':'false'">
        <v-icon v-if="!drawer">fa-bars</v-icon>
        <v-icon v-if="drawer">fa-times</v-icon>
      </button>
      <div class="nav-title">
        Administración del dinero
      </div>
      <div :aria-hidden="drawer?false:true" class="menu-list">
        <ul aria-label="listado de temas">
          <li v-for="(item,index) in menubots"  v-if="item.visto" :key="item.name" :id="'nav-item-'+index">
            <router-link :tabindex="drawer?0:-1" :aria-label=" item.name" @click.native="clickNav, hideNav()" :to="item.link" :class="{'router-link-active':item.active}">
              {{ item.name }}
            </router-link>
          </li>
        </ul>
        <button @click="drawer = false" aria-label="Cerrar menú de navegación"></button> 
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    linksPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      drawer: false,
      menubots: [
        {
          name: "Introducción",
          link: this.linksPath + "1",
          visto: true,
          pages: [1, 1],
          active: false
        },
        {
          name: "¿Qué es administrar el dinero?",
          link: this.linksPath + "2",
          visto: false,
          pages: [2, 3],
          active: false
        },
        {
          name: "Metas",
          link: this.linksPath + "4",
          visto: false,
          pages: [4, 6],
          active: false
        },
        {
          name: "Actividad",
          link: this.linksPath + "7",
          visto: false,
          pages: [7, 8],
          active: false
        },
        {
          name: "Decisiones",
          link: this.linksPath + "9",
          visto: false,
          pages: [9, 10],
          active: false
        },
        {
          name: "Actividad",
          link: this.linksPath + "11",
          visto: false,
          pages: [11, 11],
          active: false
        },
        {
          name: "¿Cómo mejorar la efectividad?",
          link: this.linksPath + "12",
          visto: false,
          pages: [12, 12],
          active: false
        },
        {
          name: "Flujo de efectivo",
          link: this.linksPath + "13",
          visto: false,
          pages: [13, 14],
          active: false
        },
        {
          name: "Ingresos y egresos",
          link: this.linksPath + "15",
          visto: false,
          pages: [15, 15],
          active: false
        },
        {
          name: "Presupuesto",
          link: this.linksPath + "16",
          visto: false,
          pages: [16, 18],
          active: false
        },
        {
          name: "Ingresos",
          link: this.linksPath + "19",
          visto: false,
          pages: [19, 21],
          active: false
        },
        {
          name: "Calculadora de presupuesto",
          link: this.linksPath + "22",
          visto: false,
          pages: [22, 23],
          active: false
        },
        {
          name: "Presupuesto mensual: ingresos",
          link: this.linksPath + "24",
          visto: false,
          pages: [24, 26],
          active: false
        },
        {
          name: "Gastos",
          link: this.linksPath + "27",
          visto: false,
          pages: [27, 31],
          active: false
        },
        {
          name: "Presupuesto mensual: gastos",
          link: this.linksPath + "32",
          visto: false,
          pages: [32, 34],
          active: false
        },
        {
          name: "Su presupuesto",
          link: this.linksPath + "35",
          visto: false,
          pages: [35, 38],
          active: false
        },
        {
          name: "Análisis del presupuesto",
          link: this.linksPath + "39",
          visto: false,
          pages: [39, 44],
          active: false
        },
        {
          name: "Patrimonio",
          link: this.linksPath + "45",
          visto: false,
          pages: [45, 48],
          active: false
        },
        {
          name: "Calcule su patrimonio",
          link: this.linksPath + "49",
          visto: false,
          pages: [49, 53],
          active: false
        },
        {
          name: "Recomendaciones",
          link: this.linksPath + "54",
          visto: false,
          pages: [54, 55],
          active: false
        },
        {
          name: "Errores comunes",
          link: this.linksPath + "56",
          visto: false,
          pages: [56, 56],
          active: false
        },
        {
          name: "Conclusión",
          link: this.linksPath + "57",
          visto: false,
          pages: [57, 57],
          active: false
        },       
      ]
    };
  },
  methods: {
    clickNav() {
      var routeArr = this.$route.path.split("/");
      var pageNum = routeArr[routeArr.length - 1];
      this.menubots.forEach(function (element) {
        if (element.pages[0] <= pageNum) {
          element.visto = true;
        }
        if (pageNum >= element.pages[0] && pageNum <= element.pages[1]) {
          this.$store.commit("temaName", element.name);
          element.active = true;
        } else {
          element.active = false;
        }
      }, this);
    },
    hideNav() {
      this.drawer = false;
    },
    keyUp(ev){
      if(ev.keyCode == 27){
        this.drawer = false;
      }
    },
    openNav(){
      document.getElementById("nav-item-0").focus();
    }
  },
  computed: {
    conteoPags() {
      return this.$store.state.paginas;
    }
  },
  watch: {
    $route() {
      this.clickNav();
    }
  },
  mounted() {
    this.clickNav();
  }
};
</script>

<style lang="scss">
@import "./Menunav";
</style>



// WEBPACK FOOTER //
// Menunav.vue?a0a808a4